require('./common-footer.jade')

CommonFooterDirective = ->
  restrict: "A"
  replace: false
  templateUrl: "components/common-footer/common-footer.jade"

module.exports = CommonFooterDirective



// WEBPACK FOOTER //
// ./~/coffeelint-loader!./ngapp/javascript/web/components/common-footer/common-footer-directive.coffee